import React, { PropsWithChildren, useMemo } from 'react'
import clsx from 'clsx'
import { ButtonGroup as ButtonGroupStyles } from '@airbus/elements/elements'
import Button from '../Button'
import IconButton from '../IconButton'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

type Props = PropsWithChildren<{
  /**
   * The size of the ButtonGroup<br />
   * @default medium
   */
  size?: 'small' | 'medium' | 'large'
}>

export type ButtonGroupProps = Props & CommonProps

const useStyles = createUseStyles(ButtonGroupStyles, 'buttongroup')

const ButtonGroup = (props: ButtonGroupProps) => {
  const { size, children, className, ...rest } = props
  const classes = useStyles()

  const buttons = useMemo(() => {
    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) {
        return null
      }

      if (child.type === Button || child.type === IconButton) {
        const childProps = child.props as any
        const { variant, ...restChildProps } = childProps
        return React.cloneElement<any>(child, {
          size,
          variant: 'ghost',
          ...restChildProps,
        })
      }
      return child
    })
  }, [children, size])

  return (
    <div role='group' className={clsx(className, classes.root, size && classes[`_${size}`])} {...rest}>
      {buttons}
    </div>
  )
}

export default ButtonGroup
